<template>
  <div class="comment-item">
    <router-link class="comment-item__avatar" :to="'/user/'+data.userInfo.userId" target="_blank">
      <user-avatar :url="data.userInfo.avatar" :round="true"></user-avatar>
    </router-link>
    <div class="comment-item__main">
      <div class="comment-item__userinfo ellipsis">
        <router-link :to="'/community/user/'+data.userInfo.userId" class="comment-item__username" target="_blank">
          <span style="margin-right:5px">{{ $formatUserName(data.userInfo) }}</span>
          <span v-if="data.isAuthor === '1'" style="margin-left:5px">(作者)</span>
        </router-link>
      </div>
      <p class="comment-item__content" v-html="formatContent(data.commentInfo.commentContent)"></p>
      <div class="comment-item__meta">
        <span class="comment-item__meta__item time">{{ formatTime(data.commentInfo.createTime) }}</span>
        <span class="comment-item__meta__item" @click.stop="commentLike('comment',data)">
          <img src="@/assets/images/like-active.svg" class="action-item__icon" v-if="data.commentInfo.likeStatus === '1'" />
          <span v-else>
            <img src="@/assets/images/like.svg" class="action-item__icon action-item__default"  />
            <img src="@/assets/images/like-active.svg" class="action-item__icon action-item__active" />
          </span>
          <span class="action-item__desc" v-if="data.commentInfo.likeCount > 0">{{ data.commentInfo.likeCount }}</span>
          <span class="action-item__desc" v-else>点赞</span>
        </span>
        <span class="comment-item__meta__item" @click.stop="reply('comment',data)">
          <img class="action-item__icon action-item__default" src="@/assets/images/comment.svg">
          <img class="action-item__icon action-item__active" src="@/assets/images/comment-active.svg">
          <span class="action-item__desc" v-if="data.commentInfo.replyCount > 0">{{ data.commentInfo.replyCount }}</span>
          <span class="action-item__desc" v-else>回复</span>
        </span>
      </div>
      <div v-if="data.replyInfos && data.replyInfos.length" class="comment-item__reply-area">
        <div class="reply-item" v-for="(item, i) in data.replyInfos" :key="i">
          <router-link :to="'/community/user/'+item.userInfo.userId" class="comment-item__avatar" target="_blank">
            <user-avatar :url="item.userInfo.avatar" :round="true"></user-avatar>
          </router-link>
          <div class="comment-item__main">
            <div class="comment-item__userinfo ellipsis">
              <router-link :to="'/community/user/'+item.userInfo.userId" class="comment-item__username" target="_blank">
                <span style="margin-right:5px">{{ $formatUserName(item.userInfo) }}</span>
                <span v-if="item.isAuthor === '1'" style="margin-left:5px">(作者)</span>
              </router-link>
            </div>
            <p class="comment-item__content">
              <span v-if="item.replayUser.userId > 0" class="comment-item__resp-userinfo">
                回复 
                <router-link class="comment-item__resp-username" :to="'/community/user/'+item.replayUser.userId" target="_blank"> {{ $formatUserName(item.replayUser) }}:</router-link>
              </span>
              <span v-html="formatContent(item.replayInfo.replayContent)"></span>
            </p>
            <div class="comment-item__meta">
              <span class="comment-item__meta__item time">{{ formatTime(item.replayInfo.createTime) }}</span>
              <span class="comment-item__meta__item" @click.stop="commentLike('reply',item)">
                <img src="@/assets/images/like-active.svg" class="action-item__icon" v-if="item.replayInfo.likeStatus === '1'" />
                <span v-else>
                  <img src="@/assets/images/like.svg" class="action-item__icon action-item__default"  />
                  <img src="@/assets/images/like-active.svg" class="action-item__icon action-item__active" />
                </span>
                <span class="action-item__desc" v-if="item.replayInfo.likeCount > 0">{{ item.replayInfo.likeCount }}</span>
                <span class="action-item__desc" v-else>点赞</span>
              </span>
              <span class="comment-item__meta__item" @click.stop="reply('reply',item)">
                <img class="action-item__icon action-item__default" src="@/assets/images/comment.svg">
                <img class="action-item__icon action-item__active" src="@/assets/images/comment-active.svg">
                <span class="action-item__desc" v-if="item.replayInfo.commentCount > 0">{{ item.replayInfo.commentCount }}</span>
                <span class="action-item__desc" v-else>回复</span>
              </span>
            </div>
          </div>
        </div>
        <!-- <div v-if="data.replyInfos.length > 1" class="reply__more" @click="replyMore">查看全部{{ data.commentInfo.replyCount }}条回复</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {doAction} from '@/api'
import {formatTime} from '@/utils/nangzhong'
export default {
  props: {
    index: {
      type: Number,
      default: -1,
    },
    data: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 5,
    }
  },
  methods: {
    formatTime,
    formatContent(content) {
      if (!content) return '';
      // 将制表符、换行符等转换为HTML的<br>标签
      return content.replace(/(\r\n|\n|\r|\t)/g, '<br>');
    },
    reply(type,data) {
      this.$emit('reply', {
        type: type,
        data: data
      });
    },
    replyMore() {
      this.$emit('replyMore', {
          index: this.index
        })
    },
    async commentLike(type,data) {
      if (!this.$store.state.user.token) {
          this.$router.push("/login/account");
          return
      }
      let id = '';
      let likeStatus = '';
      if(type == 'comment') {
        id = data.commentInfo.commentId;
        if(data.commentInfo.likeStatus === '0') {
            this.data.commentInfo.likeStatus = '1';
            likeStatus = '1';
        } else if(data.commentInfo.likeStatus === '1') { // 取消点赞行为
            this.data.commentInfo.likeStatus = '0';
            likeStatus = '0';
        }
      } else {
        id = data.replayInfo.commentId;
        if(data.replayInfo.likeStatus === '0') {
            this.data.replyInfos.find(item => item.replayInfo.commentId === id).replayInfo.likeStatus = '1';
            likeStatus = '1';
        } else if(data.replayInfo.likeStatus === '1') { // 取消点赞行为
            this.data.replyInfos.find(item => item.replayInfo.commentId === id).replayInfo.likeStatus = '0';
            likeStatus = '0';
        }
      }
      // 点赞行为
      doAction({
        actionType: 1,
        targetId: id,
        targetType: 5,
        status: likeStatus
        }).then(res=> {
          if(type == 'comment') {
              this.data.commentInfo.likeStatus === '1' ? this.data.commentInfo.likeCount+=1 : this.data.commentInfo.likeCount-=1
          } else {
              this.data.replyInfos.find(item => item.replayInfo.commentId === id).replayInfo.likeStatus === '1' ? this.data.replyInfos.find(item => item.replayInfo.commentId === id).replayInfo.likeCount+=1 : this.data.replyInfos.find(item => item.replayInfo.commentId === id).replayInfo.likeCount-=1
          }
          if(likeStatus === '1') {
              this.$message.success('点赞成功');
          } else {
              this.$message.success('取消点赞成功');
          }
        });
    }
  }
}
</script>

<style lang='scss' scoped>
.comment-item{
  position: relative;
  padding-left: 32px;
  margin-bottom: 20px;
  background: #fff;

  .comment-item__avatar{
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    cursor: pointer;
  }

  &>.comment-item__main{
    margin-left: 14px;
    padding-bottom: 20px;
    overflow: hidden;
  }

  &:not(:last-child){
    &>.comment-item__main{
      border-bottom: 1px solid #f4f4f4;
    }
  }

  .comment-item__userinfo{
    display: flex;
    align-items: center;
    line-height: 1.5;
    font-size: 13px;
    color: #bbb;

    .comment-item__username{
      margin-right: 16px;
      display: inline-flex;
      align-items: center;
      color: #333;
      cursor: pointer;
      text-decoration: none;
    }
  }

  .comment-item__content{
    font-size: 14px;
    line-height: 1.5;
    color: #505050;
    white-space: pre-line;
    word-break: break-word;
    
    ::v-deep br {
      display: block;
      content: "";
      margin-top: 5px;
    }
  }

  .comment-item__resp-userinfo{
    display: inline-flex;
    align-items: center;

    .comment-item__resp-username{
      padding: 0 5px;
      color: #406599;
      text-decoration: none;
    }
  }

  .comment-item__meta{
    display: flex;
    margin-top: 10px;
    font-size: 13px;
    .comment-item__meta__item {
      cursor: pointer;
      margin-right: 20px;
      .action-item__desc{
        margin-left: 5px;
      }
      &:nth-of-type(1) {
        color: #999;
      }
      &:not(:nth-of-type(1)) {
        img {
          width: 16px;
        }
        color: #999;
      }
      .action-item__active{
        display: none;
      }
      &:hover{
        .action-item__default{
          display: none;
        }
        .action-item__active{
          display: inline-block;
        }
        color: $color-primary;
      }
    }
    .time{
      cursor: default !important;
      pointer-events: none !important;
    }
  }
}
.comment-item__reply-area{
  margin-top: 20px;
  padding: 0 10px;
  background: #fafbfc;
  overflow: hidden;

  .reply-item{
    position: relative;
    margin-top: 10px;
    padding-left: 32px;

    .comment-item__main{
      padding-bottom: 10px;
      margin-left: 14px;
    }

    &:not(:last-child){
      .comment-item__main{
        border-bottom: 1px solid #f4f4f4;
      }
    }
  }

  .reply__more{
    padding: 10px;
    color: #8A919F;
    cursor: pointer;
    &:hover{
      opacity: .8;
    }
  }
}
</style>
